import React, { useEffect } from "react";
import { useLocation, Switch, Redirect } from "react-router-dom";

import ROUTES, {
    ROUTES_COMPONENTS,
    ROUTES_PRELOAD_CONFIG,
    applyPartnerPrefixInRoutesConfigs,
} from "../../constants/routes";
import QuotationFlowRoute from "../../components/QuotationFlowRoute";
import MainContainer from "./components/main-container";
import LazyQuotePopup from "../home-insurance-landing/components/QuotePopup/LazyQuotePopup";
import useWindowResize from "../../hooks/useWIndowResize";
import PreloadComponents from "../../components/PreloadComponents";
import { PARTNER_TYPE } from "../../constants/datalayer";
import { useActions } from "../../hooks/useActions";
import { loadActivePromotion } from "../../redux/home-insurance/home-insurance.actions";
import { isCallcenter } from "../../libs/helpers/channel";

const QuotePopup = React.lazy(() =>
    import("../home-insurance-landing/components/QuotePopup")
);

export const getPathWithPartner = (path, partner, partnerType) => {
    if (partnerType === PARTNER_TYPE.client) {
        return `/${partner}${path}`;
    }
    if (partnerType === PARTNER_TYPE.company) {
        return `/empresas/${partner}${path}`;
    }

    return path;
};

const HomeInsuranceRoutes = ({
    partner = "Pacífico",
    partnerType = PARTNER_TYPE.default,
}) => {
    const location = useLocation();
    const { isMobile } = useWindowResize();
    const routePartnerPrefix =
        partnerType === PARTNER_TYPE.company ? `empresas/${partner}` : partner;
    applyPartnerPrefixInRoutesConfigs(routePartnerPrefix);
    const actions = useActions(
        {
            loadActivePromotion,
        },
        []
    );
    useEffect(() => {
        const _channel =
            partnerType === PARTNER_TYPE.default || isCallcenter(partner)
                ? null
                : partner;
        actions.loadActivePromotion({ channel: _channel });
    }, [actions, partner, partnerType]);
    return (
        <>
            <MainContainer partner={partner} partnerType={partnerType}>
                <Switch location={location}>
                    <QuotationFlowRoute
                        path={getPathWithPartner(
                            ROUTES.HOME_INSURANCE.LANDING,
                            partner,
                            partnerType
                        )}
                        partner={partner}
                        partnerType={partnerType}
                        systemPath={ROUTES.HOME_INSURANCE.LANDING}
                        component={ROUTES_COMPONENTS.HOME_INSURANCE.LANDING}
                    />
                    <QuotationFlowRoute
                        path={getPathWithPartner(
                            ROUTES.HOME_INSURANCE.THANKS,
                            partner,
                            partnerType
                        )}
                        partner={partner}
                        partnerType={partnerType}
                        systemPath={ROUTES.HOME_INSURANCE.THANKS}
                        component={ROUTES_COMPONENTS.HOME_INSURANCE.THANKS}
                    />

                    <Redirect
                        to={getPathWithPartner(
                            ROUTES.HOME_INSURANCE.LANDING,
                            partner,
                            partnerType
                        )}
                    />
                </Switch>
            </MainContainer>
            {isMobile ? <LazyQuotePopup /> : <QuotePopup />}
            <PreloadComponents preloadConfig={ROUTES_PRELOAD_CONFIG.HOME_INSURANCE} />
        </>
    );
};

export default HomeInsuranceRoutes;
